/**
 * ./exercise4/exercise4.js
 * 
 * This module is similar with previous exercises. 
 * 
 */

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom"; // useNavigate instead of useHistory
import "../exercise3/Exercise3.css";
import Curtain from "../components/Curtain"; // Import the reusable Curtain component
import doublewordIcon from "./icons/picture-word-icon.svg";
import { API_BASE_URL } from "../config";

const Exercise4 = () => {
  const [isCurtainActive, setIsCurtainActive] = useState(true);
  const [isExiting, setIsExiting] = useState(false);
  const navigate = useNavigate(); // Create a navigate function for navigation
  const [userData, setUserData] = useState(null); // We added this

  // We added this
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/user/me`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
        });
        const data = await response.json();
        setUserData(data);
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };
    fetchUserData();
  }, []);

  useEffect(() => {
    // Timer for curtain
    const curtainTimer = setTimeout(() => {
      setIsCurtainActive(false);
    }, 2000);

    // Timer for auto navigation
    // const navigationTimer = setTimeout(() => {
    //   setIsExiting(true);
    //   setTimeout(() => {
    //     navigate('/exercise4intro');
    //   }, 0);
    // }, 3000);

    // Cleanup both timers
    return () => {
      clearTimeout(curtainTimer);
    };
  }, [navigate]);

  return (
    <div className={`exercise3-page ${isExiting ? "fade-out" : ""}`}>
      {/* Display the curtain and set it to "disappear" */}
      {isCurtainActive && <Curtain disappear={true} duration={2000} />}

      {/* Text content */}
      <div className="exercise3-header">
        <h1>Exercise 4: Picture-Word Association</h1>
      </div>

      {/* Blue bottom area */}
      <div className="exercise3-bottom">
        <img
          className="exercise3-icon"
          src={doublewordIcon}
          alt="DoublewordIcon"
        />
        <button
          className="start-exercise"
          onClick={() => {
            if (userData.exercisesUnlocked[3] >= 1) {
              navigate("/exercise4intro");
            } else {
              navigate("/Warmupwelcome", { state: { exerciseNumber: 4} });
            }
            setIsExiting(true);
          }}
        >
          <b>START</b>
        </button>
      </div>
    </div>
  );
};

export default Exercise4;
